// filepath: apps/client/src/constants/timekeeping.ts
export const getTimekeepingModuleId = (domainId?: string | null) => 
    domainId ? `timekeeping-module-id-${domainId}` : 'timekeeping-module-id';

export const getTimeEntrySheetId = (domainId?: string | null) => 
    domainId ? `timeentry-sheet-id-${domainId}` : 'timeentry-sheet-id';

export const getFieldIds = (domainId?: string | null) => {
  const s = domainId ? `-${domainId}` : '';
  return {
    startDate: `timeentry-startdate-id${s}`,
    startTime: `timeentry-starttime-id${s}`,
    endDate: `timeentry-enddate-id${s}`,
    endTime: `timeentry-endtime-id${s}`,
    duration: `timeentry-duration-id${s}`,
    hierarchy1: `timeentry-hierarchy1-id${s}`,
    hierarchy2: `timeentry-hierarchy2-id${s}`,
    billable: `timeentry-billable-id${s}`,
    notes: `timeentry-notes-id${s}`,
    source: `timeentry-source-id${s}`,
    userId: `timeentry-userid-id${s}`,
  } as const;
};

// Legacy constants for backwards compatibility (default domain)
export const TIMEKEEPING_MODULE_ID = 'timekeeping-module-id-marion-tenant-id';
export const TIMEENTRY_SHEET_ID = 'timeentry-sheet-id-marion-tenant-id';
export const FIELD_IDS = getFieldIds(null);